import { MultiStepFormStep } from 'components/Form/MultiStepForm/MultiStepFormTypes';

import { getFieldsToValidateByStep } from './getFieldsToValidateByStep';

export function getFirstStepWithError(
  steps: MultiStepFormStep[],
  errors: APIErrors,
) {
  const errorNameArray = Object.keys(errors);
  const fieldsByStep = getFieldsToValidateByStep(steps, steps.length);

  for (let stepNum = 0; stepNum < steps.length; stepNum++) {
    const stepErrors = errorNameArray.filter((errorName) =>
      fieldsByStep[stepNum]?.find(
        (fieldName) =>
          // e.g. addresses.0.line1 => addresses.0
          errorName.replace(/([0-9]+)\..+/, '$1') === fieldName,
      ),
    );

    if (stepErrors.length > 0) {
      return stepNum;
    }
  }

  return null;
}
